import * as React from "react"
import { Box, Typography } from "@mui/material"

import { HierarchicalTextBlock, ImageSkuBlock, ShowDetails, LinkIconBlock } from "@components"
import { BACKEND_APIS } from "@constants"
import { CategoryText, SkuLabelWrap } from "../@components"
import { useAdminNewListedList } from "../../../@hooks"


export default function productRawColumn() {
	return [{
		name: 'productID', label: 'Product ID',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: 'repeatedSku', label: 'Repeated SKU',
		options: {
			filterType: "checkbox", display: 'excluded',
			customBodyRowRender: value => value ? 'YES' : 'NO'
		}
	}, {
		name: 'brandRaw', label: 'Brand Raw',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: "productName", label: "Product Raw",
		options: {
			filterType: 'textField',
			setCellProps: () => ({ sx: {  whiteSpace: "nowrap", position: "sticky", left: 0 } }),
			setCellHeaderProps: () => ({ sx: { whiteSpace: "nowrap", position: "sticky", left: 0, zIndex: 101} }),
			customBodyRowRenderLite: (value, rowData) => <ProductRowCell productName={value} rowData={rowData} />
		}
	}]
}

const ProductRowCell = ({ productName, rowData }) => {
	const { isOpenDrawer, handleClickDetails } = useAdminNewListedList(rowData, rowData.date, rowData.siteID, rowData.productID)

	const isOpenDrawerClass = isOpenDrawer ? 'is-open' : ''

	// Sin `Nº Items`: el mapeo es del **producto** —`DIPI_SKU_MAPPING` tiene la clave
	// `(id_site, product_id)`—, así que aquellas subfilas eran el mismo registro repetido, cada una
	// con su interruptor de validar. Retirado el 2026-09-14.

	const repeatedSkuColor = rowData.repeatedSku ? 'success' : 'error'
	const repeatedSkuLabel = rowData.repeatedSku ? 'yes' : 'no'

	const validatedColor = rowData.validated ? 'success' : 'error'
	const validatedLabel = rowData.validated ? 'yes' : 'no'

	const imageURL = `${BACKEND_APIS.SKU_DATA}/image-resource?url=${rowData.thumbnail}`

	return <Box className={isOpenDrawerClass} sx={{ display: 'inline-flex', alignItems: 'center' }}>
		<ImageSkuBlock imageURL={imageURL} name={productName} hideName imageProps={{ minWidth: 50, minHeight: 50 }} contentProps={{ sx: {margin: '', mr: 3} }} />
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			<HierarchicalTextBlock title="Product ID: " titleValue={rowData.productID} />
			<HierarchicalTextBlock title="Repeated SKU: " titleValue={<CategoryText label={repeatedSkuLabel} color={repeatedSkuColor}  />} />
			<HierarchicalTextBlock title="Brand Raw: " titleValue={rowData.brandRaw} />
			<HierarchicalTextBlock title="Validated SKU: " titleValue={<CategoryText label={validatedLabel} color={validatedColor}  />} />
			<Box>
				<Box sx={{ display: 'flex'}}>
					<SkuLabelWrap label={productName} maxWidth={400}/>
					<LinkIconBlock url={rowData.productURL} variant="body2" sx={{ display: "inline-block" }} linkProps={{ sx: { display: 'flex' } }}/>
				</Box>
				{!!rowData.category && <Typography variant="caption" sx={{display: "block", color: "text.disabled"}}>
					<Box title={rowData.category }>
						Category: {rowData.category}
					</Box>
				</Typography>}
		
				<ShowDetails onClick={handleClickDetails}/>
      		</Box>
		</Box>
	</Box>
}